import { defineMessages } from 'react-intl-next';

export const messages: {
	connect: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectThirdPartyProductDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectThirdPartyProductTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectThirdPartyProductTitleAlternate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dismiss: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	connectThirdPartyProductTitle: {
		id: 'dynamic-cards-search-page.connect_third_party_product_title',
		defaultMessage: 'Your admin has added {product}!',
		description: 'Title shown to prompt users to connect third-party products',
	},
	connectThirdPartyProductTitleAlternate: {
		id: 'dynamic-cards-search-page.connect_third_party_product_title_alternate',
		defaultMessage: '{product} is now available!',
		description:
			'Alternate title shown to prompt users to connect third-party products (not added by admin)',
	},
	connectThirdPartyProductDescription: {
		id: 'dynamic-cards-search-page.connect_third_party_product_description',
		defaultMessage: 'Connect your account to see missing results',
		description: 'Description shown to prompt users to connect third-party products',
	},
	dismiss: {
		id: 'dynamic-cards-search-page.oauth-message-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the oauth message',
	},
	connect: {
		id: 'dynamic-cards-search-page.oauth-message-connect',
		defaultMessage: 'Connect',
		description: 'Message for button to connect the third-party product',
	},
});
